<template>
    <div id="vipkalameetingdetails" class="container-fluid text-center">
        <Navigator></Navigator>
        <div v-if="kalameeting && kalameeting.name">
            <div class="row text-center m-3">
                <div class="col col-lg-6 mx-auto card p-5 text-center">
                    <h1>{{kalameeting.name}}</h1>
                    <p>By {{kalameeting.owner.firstName}}
                        {{kalameeting.owner.lastName}}</p>
                    <div>
                        <b-badge v-if="kalameeting.availableTickets === 0"
                                 variant="danger" class="p-2">
                            Sold Out
                        </b-badge>
                        <b-badge v-else="meeting.availableTickets < meeting.totalTickets"
                                 class="p-2" variant="primary">
                            {{ kalameeting.availableTickets }}
                            / {{ kalameeting.totalTickets }}
                            Tickets Available
                        </b-badge>
                    </div>
                    <p class="p-3">
                        {{new Date(kalameeting.date)
                        .toLocaleDateString()}}<br>
                        {{kalameeting.startTime}} -
                        {{kalameeting.endTime}}
                    </p>
                    <p>
                        Line Starts:
                        {{new Date(kalameeting.lineStart).toLocaleDateString()}}
                        {{new Date(kalameeting.lineStart).toLocaleTimeString()}}
                    </p>
                    <h4>Details</h4>
                    <p>
                        Slot Price: {{kalameeting.slotPrice}}<br>
                        Time Slot: {{kalameeting.timeSlot}} min<br>
                        Break Time: {{kalameeting.breakTime}} min after
                        {{kalameeting.slotsInARow}} slots<br>
                    </p>
                    <div v-if="kalameeting.owner.uid !==
                                $store.state.currentUser.uid" >
                        <b-button pill @click="join" class="mt-4 my-2">
                            Join Kalameeting Now</b-button><br><br>
                    </div>
                    <router-link class="col" to="/">Back home</router-link>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<style>
    #vipkalameetingdetails {
        background-image: url("../../assets/images/texture.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-attachment: fixed;
        min-height: 100%;
        min-width: 100%;
    }
</style>

<script>
import Navigator from '../../components/Navigator.vue';
import firebase from '../../firebase';

export default {
    data() {
        return {
            kalameeting: {}
        };
    },
    components: {
        Navigator
    },
    methods: {
        join() {
            this.$router.push({
                name: 'FANCameraView', params: { id: this.$route.params.id }
            });
        }
    },
    mounted() {
        console.log('saadsa');
        if (!this.$store.state.currentKalameeting || !this.$store.state.kalameetingDetails) {
            firebase.kalameetingCollection.doc(this.$route.params.id)
                .get()
                .then((res) => {
                    this.kalameeting = res.data();
                    this.$store.commit('setCurrentKalameeting', res.data().id);
                    this.$store.commit('setKalameetingDetails', res.data());
                    if (this.$store.state.currentUser.uid === this.kalameeting.owner.uid) {
                        this.$router.push({ name: 'VIPKalameetingDetails', params: { id: this.kalameeting.id } });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            this.kalameeting = this.$store.state.kalameetingDetails;
        }
    }
};
</script>
